export default __webpack_public_path__ + "static/media/new_page_banner@2x.d3e78b04.jpg";